import { ERROR_TYPES } from 'personalization-lib/constants/error';
export const parseSegmentError = errorResponse => {
  var _errorResponse$cause;
  return errorResponse && ((_errorResponse$cause = errorResponse.cause) === null || _errorResponse$cause === void 0 ? void 0 : _errorResponse$cause.cause);
};
export const parsePersonalizationError = errorResponse => {
  var _errorResponse$cause2;
  return errorResponse && ((_errorResponse$cause2 = errorResponse.cause) === null || _errorResponse$cause2 === void 0 ? void 0 : _errorResponse$cause2.cause);
};
export const isNotFoundError = error => {
  return (error === null || error === void 0 ? void 0 : error.errorType) === ERROR_TYPES.NOT_FOUND;
};